export default (name: string | undefined): string | undefined =>
  name ? name.replace(/\\/g, "/").replace(/.*\//, "") : undefined
